import { defineMessages } from 'react-intl';

export default defineMessages({
    paDriverFirstName: {
        id: 'quoteandbind.ba.directives.templates.ba-edit-driver.First Name',
        defaultMessage: 'First Name',
    },
    paDriverMiddleName: {
        id: 'quoteandbind.ba.directives.templates.ba-edit-driver.Middle Name',
        defaultMessage: 'Middle Name',
    },
    paDriverLastName: {
        id: 'quoteandbind.ba.directives.templates.ba-edit-driver.Last Name',
        defaultMessage: 'Last Name',
    },
    paDriverDateOfBirth: {
        id: 'quoteandbind.ba.directives.templates.ba-edit-driver.Date of Birth',
        defaultMessage: 'Date of Birth',
    },
    paDriverGender: {
        id: 'quoteandbind.ba.directives.templates.ba-edit-driver.Gender',
        defaultMessage: 'Gender',
    },
    paDriverGenderPlaceholder: {
        id: 'quoteandbind.ba.directives.templates.ba-edit-driver.-- Choose Driver Gender --',
        defaultMessage: '-- Choose Driver Gender --',
    },
    paDriversLicenseNumber: {
        id: 'quoteandbind.ba.directives.templates.ba-edit-driver.Drivers License Number',
        defaultMessage: 'Drivers License Number',
    },
    paDriverLicenceProvince: {
        id: 'quoteandbind.ba.directives.templates.ba-edit-driver.License Province',
        defaultMessage: 'License Province',
    },
    paDriverYearFirstLicensed: {
        id: 'quoteandbind.ba.directives.templates.ba-edit-driver.Year First Licensed',
        defaultMessage: 'Year First Licensed',
    },
    paDriverNumberOfAccidents: {
        id: 'quoteandbind.ba.directives.templates.ba-edit-driver.Number Of Accidents',
        defaultMessage: 'Number Of Accidents',
    },
    paDriverNumberOfViolations: {
        id: 'quoteandbind.ba.directives.templates.ba-edit-driver.Number Of Violations',
        defaultMessage: 'Number Of Violations',
    },
    paDriverLicenseYear: {
        id: 'quoteandbind.ba.directives.templates.ba-edit-driver.-- Choose License Year --',
        defaultMessage: '-- Choose License Year --',
    },
    paDriverLicenseProvince: {
        id: 'quoteandbind.ba.directives.templates.ba-edit-driver.-- Choose License Province --',
        defaultMessage: '-- Choose License Province --',
    },
    paDriverMaritalStatus: {
        id: 'quoteandbind.ba.directives.templates.ba-edit-driver.Marital Status',
        defaultMessage: 'Marital Status',
    },
    paDriverMaritalStatusPlaceholder: {
        id: 'quoteandbind.ba.directives.templates.ba-edit-driver.-- Choose Marital Status --',
        defaultMessage: '-- Choose Marital Status --',
    },
    paDriverDateOfBirth: {
        id: 'quoteandbind.ba.directives.templates.ba-edit-driver.First License Date',
        defaultMessage: 'First License Date',
    },
    paDriverLicenceState: {
        id: 'quoteandbind.ba.directives.templates.ba-edit-driver.License Status',
        defaultMessage: 'License Status',
    },
    paDriverLicenseState: {
        id: 'quoteandbind.ba.directives.templates.ba-edit-driver.-- Choose License Status --',
        defaultMessage: '-- Choose License Status --',
    },
    paDriverTrainingCert: {
        id: 'quoteandbind.ba.directives.templates.ba-edit-driver.Has Driver Training Certificate?',
        defaultMessage: 'Has Driver Training Certificate?',
    },
    paDriverStudentAwayHome: {
        id: 'quoteandbind.ba.directives.templates.ba-edit-driver.Student Away from Home?',
        defaultMessage: 'Student Away from Home?',
    },
    paDriverIsInsured: {
        id: 'quoteandbind.ba.directives.templates.ba-edit-driver.Driver Previously Insured?',
        defaultMessage: 'Driver Previously Insured?',
    },
    paDriverConvictionDate: {
        id: 'quoteandbind.ba.directives.templates.ba-edit-driver.Conviction Date',
        defaultMessage: 'Conviction Date',
    },
    paDriverConvictionType: {
        id: 'quoteandbind.ba.directives.templates.ba-edit-driver.Conviction Type',
        defaultMessage: 'Conviction Type',
    },
    paDriverConvictionCode: {
        id: 'quoteandbind.ba.directives.templates.ba-edit-driver.Conviction Code',
        defaultMessage: 'Conviction Code',
    },
    paDriverConvictionCode: {
        id: 'quoteandbind.ba.directives.templates.ba-edit-driver.Conviction Severity',
        defaultMessage: 'Conviction Severity',
    },
    paDriverConvictionRemove: {
        id: 'quoteandbind.ba.directives.templates.ba-edit-driver.Remove',
        defaultMessage: 'Remove',
    },
    suspensionCount: {
        id: 'quoteandbind.ba.directives.templates.ba-edit-driver.Suspension:',
        defaultMessage: 'Suspension: ',
    },
    baAddConvictionSection: {
        id: 'quoteandbind.ba.directives.templates.ba-edit-driver.Conviction',
        defaultMessage: 'Conviction',
    },
    baConvictionCount: {
        id: 'quoteandbind.ba.directives.templates.ba-edit-driver.Conviction:',
        defaultMessage: 'Conviction:',
    },
    baAddSuspensionSection: {
        id: 'quoteandbind.ba.directives.templates.ba-edit-driver.Suspension',
        defaultMessage: 'Suspension',
    },
    addRow: {
        id: 'quoteandbind.ba.directives.templates.ba-edit-driver.Add',
        defaultMessage: 'Add',
    },
    addClassificationButtonId: {
        id: 'quoteandbind.ba.directives.templates.ba-edit-driver.Add License Class',
        defaultMessage: 'Add License Class',
    },
    orderMvrButtonId: {
        id: 'quoteandbind.ba.directives.templates.ba-edit-driver.Order MVR',
        defaultMessage: 'Order MVR',
    },

    suspensionCode: {
        id: 'quoteandbind.ba.directives.templates.ba-edit-driver.Suspension Code',
        defaultMessage: 'Suspension Code',
    },
    referenceNumber: {
        id: 'quoteandbind.ba.directives.templates.ba-edit-driver.Reference #',
        defaultMessage: 'Reference #',
    },
    startDate: {
        id: 'quoteandbind.ba.directives.templates.ba-edit-driver.Suspension Date',
        defaultMessage: 'Suspension Date',
    },
    expiryDate: {
        id: 'quoteandbind.ba.directives.templates.ba-edit-driver.Expiry Date',
        defaultMessage: 'Expiry Date',
    },
    description: {
        id: 'quoteandbind.ba.directives.templates.ba-edit-driver.Suspension Description',
        defaultMessage: 'Suspension Description',
    },
    reinstatementDate: {
        id: 'quoteandbind.ba.directives.templates.ba-edit-driver.Reinstatement Date',
        defaultMessage: 'Reinstatement Date',
    },
    licenseClassHeader: {
        id: 'quoteandbind.ba.directives.templates.ba-edit-driver.License Class',
        defaultMessage: 'License Class',
    },
    licenseDateHeader: {
        id: 'quoteandbind.ba.directives.templates.ba-edit-driver.License Class Date',
        defaultMessage: 'License Class Date',
    },
    paDriverHasMotorCycleCert: {
        id: 'quoteandbind.ba.directives.templates.ba-edit-driver.Has Motorcycle Training Certificate',
        defaultMessage: 'Has Motorcycle Training Certificate',
    },
    paDriverConvictionDate: {
        id: 'quoteandbind.ba.directives.templates.ba-edit-driver.Conviction Date',
        defaultMessage: 'Conviction Date',
    },
    paDriverReationToInsured: {
        id: "quoteandbind.ba.directives.templates.ba-edit-driver.Relationship To Primary Named Insured",
        defaultMessage: "Relationship To Primary Named Insured"
    },
    paDriverOccupation: {
        id: "quoteandbind.ba.directives.templates.ba-edit-driver.Occupation",
        defaultMessage: "Occupation"
    },
    paDriverEmploymentType: {
        id: "quoteandbind.ba.directives.templates.ba-edit-driver.Type Of Employment",
        defaultMessage: "Type Of Employment"
    },
    paDriverLicenseReinstatementDate: {
        id: "quoteandbind.ba.directives.templates.ba-edit-driver.License Reinstatement Date",
        defaultMessage: "License Reinstatement Date"
    },
    paDriverLicenseReinstatementDate: {
        id: "quoteandbind.ba.views.ba-driver-details.License Classification",
        defaultMessage: "License Classification"
    },
    paPriorPolHis: {
        id: "quoteandbind.ba.views.ba-driver-details.Prior Policy History",
        defaultMessage: "Prior Policy History"
    },
    paMvrFillDetails: {
        id: "quoteandbind.ba.views.ba-driver-details.Please fill all required data before ordering MVR",
        defaultMessage: "Please fill all required data before ordering MVR"
    },
    paMvrDetailsMissing: {
        id: "quoteandbind.ba.views.ba-driver-details.Error",
        defaultMessage: "Error"
    },
    paDistanceAwayFromHome: {
        id: 'quoteandbind.ba.directives.templates.ba-edit-driver.Distance Away From Home (kms)',
        defaultMessage: 'Distance Away From Home (kms)',
    },
    sameAsAccountHolder:{
        id: "quoteandbind.ba.directives.templates.ba-edit-driver.Same as Account Holder",
        defaultMessage : "Same as Account Holder"
    },
    mvrStatus:{
        id: "quoteandbind.ba.directives.templates.ba-edit-driver.MVR Status",
        defaultMessage : "MVR Status"
    },
    paDriverTemporaryFarmEmployee: {
        id: "quoteandbind.ba.directives.templates.ba-edit-driver.Temporary Farm Employee",
        defaultMessage : "Temporary Farm Employee"
    },
    isEnrolledInTelematics_EY: {
        id: 'quoteandbind.ba.directives.templates.ba-edit-driver.Driver Enrolled in Telematics?',
        defaultMessage: 'Driver Enrolled in Telematics?'
    },
    telematicsEmail: {
        id: 'quoteandbind.ba.views.ba-driver-details.Telematics Email',
        defaultMessage: 'Telematics Email'
    },
    paIsPrevLicensedOutsideOfON_EY: {
        id: 'quoteandbind.ba.directives.templates.ba-edit-driver.Previously Licensed outside of Ontario?',
        defaultMessage: 'Previously Licensed outside of Ontario?'
    }
});
